import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import axios from "axios";
import VueAxios from "vue-axios";
import i18n from "./locales";
import VueHotKey from "v-hotkey";
import vClickOutside from "v-click-outside";
import VueApexCharts from "vue-apexcharts";

Vue.use(VueAxios, axios);

Vue.config.productionTip = false;

Vue.use(VueApexCharts);
Vue.use(vClickOutside);
Vue.use(VueHotKey, {
  ctrl_up: 17,
  shift_up: 16,
  alt_up: 18,
  up: 38,
  down: 40,
});
/* eslint-disable */
Vue.component("apexchart", VueApexCharts);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
